import { render, staticRenderFns } from "./ClaimField.vue?vue&type=template&id=3ec14a15"
import script from "./ClaimField.vue?vue&type=script&lang=js"
export * from "./ClaimField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports